<template>
  <div class="mod-operation-log">
    <div class="page-header">
      <span class="page-header__title">操作日志</span>
    </div>

    <div class="page-body">
      <div class="toolbar">
        <el-input
          v-model="dataForm.keyword"
          placeholder="请输入内容"
          clearable
          class="toolbar__search"
          @keyup.enter.native="handleSearch">
          <el-select v-model="searchField" slot="prepend" class="toolbar__prepend">
            <el-option label="操作人" value="creatorName"></el-option>
            <el-option label="操作内容" value="operation"></el-option>
          </el-select>
        </el-input>
        <el-date-picker
          v-model="dateRange"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          class="toolbar__date"
          @change="handleSearch">
        </el-date-picker>
        <el-select
          v-model="dataForm.status"
          placeholder="全部状态"
          clearable
          class="toolbar__select"
          @change="handleSearch">
          <el-option label="成功" :value="1"></el-option>
          <el-option label="失败" :value="0"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <div class="toolbar__right">
          <el-button icon="el-icon-download" @click="handleExport">导出</el-button>
        </div>
      </div>

      <div class="panel">
        <el-table :data="dataList" v-loading="loading" style="width: 100%;">
          <el-table-column prop="createDate" label="时间" min-width="170"></el-table-column>
          <el-table-column label="操作人" min-width="130">
            <template slot-scope="scope">{{ scope.row.creatorName || '—' }}</template>
          </el-table-column>
          <el-table-column label="模块" min-width="120">
            <template slot-scope="scope">{{ scope.row.moduleName }}</template>
          </el-table-column>
          <el-table-column label="操作" min-width="140">
            <template slot-scope="scope">{{ scope.row.operation || '—' }}</template>
          </el-table-column>
          <el-table-column label="详情" min-width="260" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.requestParams || '—' }}</template>
          </el-table-column>
          <el-table-column label="状态" width="90">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small">
                {{ scope.row.status === 1 ? '成功' : '失败' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="耗时" width="100">
            <template slot-scope="scope">{{ scope.row.requestTime ? `${scope.row.requestTime}ms` : '—' }}</template>
          </el-table-column>
          <el-table-column prop="ip" label="IP" min-width="140">
            <template slot-scope="scope">{{ scope.row.ip || '—' }}</template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handlePageChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import Cookies from 'js-cookie'
import { getOperationLogPage, resolveModule } from '@/api/sysManage'

export default {
  name: 'OperationLog',
  data () {
    return {
      loading: false,
      dataList: [],
      page: 1,
      limit: 20,
      total: 0,
      searchField: 'creatorName',
      dateRange: null,
      dataForm: {
        keyword: '',
        status: ''
      }
    }
  },

  created () {
    this.loadList()
  },

  methods: {
    buildParams () {
      const params = {
        page: this.page,
        limit: this.limit
      }
      if (this.dataForm.keyword) {
        params[this.searchField] = this.dataForm.keyword
      }
      if (this.dataForm.status !== '') {
        params.status = this.dataForm.status
      }
      if (this.dateRange && this.dateRange.length === 2) {
        params.startDate = this.dateRange[0]
        params.endDate = this.dateRange[1]
      }
      return params
    },

    loadList () {
      this.loading = true
      return getOperationLogPage(this.buildParams()).then(({ data: res }) => {
        if (res.code !== 0) {
          this.dataList = []
          this.total = 0
          return this.$message.error(res.msg)
        }
        const list = (res.data && res.data.list) || []
        this.total = (res.data && res.data.total) || 0
        this.dataList = list.map(item => ({
          ...item,
          // 日志表没有模块字段，由请求地址推导
          moduleName: resolveModule(item.requestUri)
        }))
      }).catch(() => {
        this.$message.error('加载操作日志失败')
      }).finally(() => {
        this.loading = false
      })
    },

    handleSearch () {
      this.page = 1
      this.loadList()
    },

    handleSizeChange (val) {
      this.limit = val
      this.page = 1
      this.loadList()
    },

    handlePageChange (val) {
      this.page = val
      this.loadList()
    },

    handleExport () {
      const params = this.buildParams()
      delete params.page
      delete params.limit
      const query = qs.stringify({
        token: Cookies.get('token'),
        ...params
      })
      window.location.href = `${process.env.VUE_APP_API_TARGET}${process.env.VUE_APP_BASE_API}/sys/log/operation/export?${query}`
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-operation-log {
  background-color: #f5f7fa;
  min-height: 100%;
}

.page-header {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  background-color: #fff;
  border-bottom: 1px solid #ebeef5;

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2d3d;
  }
}

.page-body {
  padding: 16px;
}

.toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;

  &__search {
    width: 320px;
    margin-right: 12px;
  }

  &__prepend {
    width: 110px;
  }

  &__date {
    margin-right: 12px;
  }

  &__select {
    width: 140px;
    margin-right: 12px;
  }

  &__right {
    margin-left: auto;
  }
}

.panel {
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px;
}

.pagination {
  margin-top: 16px;
  text-align: right;
}

::v-deep .el-table th {
  background-color: #fafbfc;
  color: #909399;
  font-weight: 500;
}

::v-deep .toolbar__prepend .el-input__inner {
  background-color: #f5f7fa;
}
</style>
